/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Report_Span_LabelInputs */

const en_us2_progress_report_span_label = /** @type {(inputs: Progress_Report_Span_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Report period`)
};

const pt_br2_progress_report_span_label = /** @type {(inputs: Progress_Report_Span_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Período do relatório`)
};

const es_419_progress_report_span_label = /** @type {(inputs: Progress_Report_Span_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Período del informe`)
};

const pt_pt2_progress_report_span_label = /** @type {(inputs: Progress_Report_Span_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Período do relatório`)
};

const fr_fr2_progress_report_span_label = /** @type {(inputs: Progress_Report_Span_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Période du bilan`)
};

const de_de2_progress_report_span_label = /** @type {(inputs: Progress_Report_Span_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berichtszeitraum`)
};

const it_it2_progress_report_span_label = /** @type {(inputs: Progress_Report_Span_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Periodo del report`)
};

/**
* | output |
* | --- |
* | "Report period" |
*
* @param {Progress_Report_Span_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_report_span_label = /** @type {((inputs?: Progress_Report_Span_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Report_Span_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_report_span_label(inputs)
	if (locale === "es-419") return es_419_progress_report_span_label(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_report_span_label(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_report_span_label(inputs)
	if (locale === "de-DE") return de_de2_progress_report_span_label(inputs)
	if (locale === "it-IT") return it_it2_progress_report_span_label(inputs)
	return en_us2_progress_report_span_label(inputs)
});
export { progress_report_span_label as "progress-report.span_label" }